import { Empty, Input } from 'antd';
import { FaSearch } from 'react-icons/fa';
import './style.less';
import { useSearchHelpItems } from '@/core/domain/helpcenter/HelpItems/HelpItems.hooks';
import { Link } from 'react-router-dom';
import { useLayoutEffect, useRef, useState } from 'react';
import { useDebounce } from '@/hooks';

export default function HelpCenterSearchBox() {
  const [search, setSearch] = useState('');
  const debounce = useDebounce(search, 1000);
  const [open, setOpen] = useState(false);

  const dropRef = useRef<HTMLDivElement>(null);

  const { data: helpItemsData } = useSearchHelpItems(debounce);

  useLayoutEffect(() => {
    if (dropRef) {
      if (!open) {
        dropRef.current?.scrollTo({ top: 0 });
      }
    }
  }, [open, dropRef]);

  return (
    <div className="help-center-search-box">
      <Input
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 100)}
        size="large"
        suffix={<FaSearch size={24} />}
        placeholder="Pesquise uma funcionalidade"
        allowClear
        className="help-center-search-input"
        value={search}
        onChange={({ target }) => setSearch(target.value)}
      />
      <div
        className="help-center-search-dropdown"
        ref={dropRef}
        data-opened={open}
      >
        <ul>
          {(!helpItemsData?.data || !helpItemsData?.data.length) && (
            <li
              style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Empty description="Não há itens a ser exibido" />
            </li>
          )}

          {helpItemsData?.data.slice(0, 10).map((item) => (
            <li
              className="help-center-search-dropdown-item"
              key={item.id}
              onClick={() => setOpen(false)}
            >
              <Link to={`/helpCenter/${item.area.id}/${item.id}`}>
                <span>{item.title}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
